import { useReportingTrialFleetStats } from '@cast/features-cluster-shared';
import { FREE_VCPU_CAP, useReportingTrial } from '@cast/shared-trial-ui';

import { OverviewCard } from './OverviewCard';
import { useNavigateToReportingUsage } from '../reportingMonetizationNavigation';

/**
 * Overview card for reporting monetization on Platform usage.
 * Navigates to billing-report/reporting (not a billing API feature key).
 */
export const ReportingOverviewCard = () => {
  const navigateToReportingUsage = useNavigateToReportingUsage();
  const { state } = useReportingTrial();
  const { avgProvisionedVcpu } = useReportingTrialFleetStats();

  const roundedUsage = Math.round(avgProvisionedVcpu);
  const isPaid = state === 'paid';

  const badgeLabel = isPaid
    ? undefined
    : state === 'active'
    ? 'Trial'
    : state === 'grace-period' || state === 'post-trial'
    ? avgProvisionedVcpu <= FREE_VCPU_CAP
      ? 'Free'
      : 'Trial ended'
    : 'Eligible';

  return (
    <OverviewCard
      title="Reporting"
      badge={badgeLabel ? { label: badgeLabel } : undefined}
      usage={{
        value: roundedUsage,
        unit: 'vCPU',
      }}
      onClick={navigateToReportingUsage}
    />
  );
};
